export default "__VITE_ASSET__CYA1BaT5__"